import { CSSObject, Theme } from '@core-ui/react-stitch';
import getSeparateLabelStyles from '../getSeparateLabelStyles';
import getTextStyles from '../getTextStyles';

const getSelectStyles = (
  hasSeparateLabel: boolean,
  isBR: boolean, 
  isBRRedesignEnabled: boolean,
) => (base: CSSObject, { theme }: { theme: Theme }): CSSObject => ({
  ...base,
  whiteSpace: 'pre-wrap',
  ...(hasSeparateLabel ? getSeparateLabelStyles() : { textAlign: 'left' }),
  height: '100%',
  ...getTextStyles(theme, isBR, isBRRedesignEnabled),
  ...isBRRedesignEnabled ? {
    direction: 'rtl',
    lineHeight: '1.43',
    paddingTop: '6px',
    paddingRight: '1.688rem',
    paddingBottom: '6px',
    paddingLeft: '1rem',
    background: 'url("data:image/svg+xml;charset=utf8,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'9\' height=\'6\' viewBox=\'0 0 9 6\'%3E%3Cpath d=\'M.003 1.533L1.118.529l3.385 3.047L7.89.529l1.114 1.004-4.5 4.05z\' style=\'fill:%23F6F4EB;fill-rule:evenodd\' /%3E%3C/svg%3E") right 8px center no-repeat',
    '&:hover' : { 
      backgroundColor: theme.color.alpha00,
    }
  } : {}
});

export default getSelectStyles;
